/**
 * Which attachments fit in one trigger request (#708).
 *
 * The cap is on the attachments' base64 size, as the add-in sends them:
 * REACT_APP_MAX_ATTACHMENT_SIZE, 40 MB: under the 40 MiB cnp-service's async accept
 * takes for the whole request, with room left for the mail's text.
 * Attachments are taken in the mail's order; one that would pass the cap is left
 * out, and the later ones that still fit are taken. Pure on purpose: no Office, so
 * the rule is tested on its own (tests/ui/specs/msg.unit.spec.ts, which applies it
 * to the .msg replay) and in the pane (tests/ui/specs/attachments.spec.ts).
 */
export interface SizedAttachment {
  name: string;
  size: number;
}

export interface FittedAttachments<T extends SizedAttachment> {
  /** In the mail's order. */
  sent: T[];
  /** The names the pane lists, in the mail's order. */
  leftOut: string[];
}

export function fitAttachments<T extends SizedAttachment>(attachments: T[], cap: number): FittedAttachments<T> {
  const sent: T[] = [];
  const leftOut: string[] = [];
  let total = 0;
  for (const attachment of attachments) {
    if (total + attachment.size <= cap) {
      sent.push(attachment);
      total += attachment.size;
    } else {
      leftOut.push(attachment.name);
    }
  }
  return { sent, leftOut };
}
